module.exports = __webpack_public_path__ + "static/media/detail_0050_t.b0210ca0.jpg";